import { Swiper } from 'swiper';
import 'swiper/css';

export default function () {
    if (document.querySelector('.other-documents__posts')) {
        initSwiper();
    }
}

const initSwiper = () => {
    const swiper = new Swiper('.other-documents__posts', {
        slidesPerView: 1.2,
        spaceBetween: 24,
        enabled: true,
        breakpoints: {
            640: {
                enabled: true,
                slidesPerView: 2.1,
                spaceBetween: 16,
            },
            900: {
                enabled: true,
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
    });
};
